import React, { Suspense, useEffect, useState } from "react"
import i18n from "../i18n";
import { Element } from "react-scroll"
import { Loader } from "./ui/Loader"
import { ButtonTop } from "./ui/ButtonTop"
import Main from "./Main"
import About from "./About";
import Service from "./Service";
import PriceBeginning from "./PriceBeginning";
import Price from "./Price";
import Contats from "./Contats";
import Header from "./Header";



function App() {
    useEffect(() => {
        const storedLang = localStorage.getItem('language');
        if (storedLang && storedLang !== i18n.language) {
            i18n.changeLanguage(storedLang);
        }
    }, []);

    const [showButtonTop, setShowButtonTop] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        setShowButtonTop(window.scrollY > 0);
      };
  
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
    return (
        <div className="App">
            {/* <Loader/> */}
                <Header />
                <Element name="main">
                    <Main />
                </Element>
                <Element name="about">
                    <About />
                </Element>
                <Element name="service">
                    <Service />
                </Element>
                <Element name="pricebeginning">
                    <PriceBeginning />
                </Element>
                <Element name="price">
                    <Price />
                </Element>
                <Element name="contats">
                    <Contats />
                </Element>
                {showButtonTop && <ButtonTop />}
    
        </div>
    )
}

export default App
